import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { Icon } from "../utils/icon/icon";
import { LanguageService } from "src/app/core/services/language-service";
import {
  LangDefinition,
  TranslocoModule,
  TranslocoService,
} from "@jsverse/transloco";
import { filter, Subscription, take } from "rxjs";
import { UpperCasePipe } from "@angular/common";
import { ClickOutsideDirective } from "../../directives/click-outside-directive";
import { Button } from "../utils/button/button";
import { SearchBar } from "../search-bar/search-bar";

@Component({
  selector: "app-header",
  imports: [
    Button,
    RouterLink,
    RouterLinkActive,
    Icon,
    TranslocoModule,
    UpperCasePipe,
    ClickOutsideDirective,
    SearchBar,
  ],
  templateUrl: "./header.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./header.scss"],
})
export class Header implements OnInit, OnDestroy {
  router = inject(Router);
  public _languageService = inject(LanguageService);

  burgerMenuOpened = signal<boolean>(false);
  private readonly translationService = inject(TranslocoService);

  currentLang = signal<string>(this.translationService.getActiveLang());
  currentRoute: string = "";

  availableLangs =
    this.translationService.getAvailableLangs() as LangDefinition[];
  private subscription: Subscription | null = null;
  languageMenuOpened = signal<boolean>(false);
  canChangeLanguage = signal<boolean>(true);
  searchBarSectionOpened = signal<boolean>(false);
  isErrorPage = signal<boolean>(false);

  ngOnInit() {
    this.currentRoute = this.router.url;

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
        this.onRouteChange(event.url);
      });
  }

  toggleSearchBarSection() {
    this.searchBarSectionOpened.set(!this.searchBarSectionOpened());
  }
  toggleLanguageMenu() {
    if (this.burgerMenuOpened()) {
      this.burgerMenuOpened.set(false);
    }
    this.languageMenuOpened.set(!this.languageMenuOpened());
  }
  toggleLanguage() {
    this._languageService.toggleLanguage();
  }

  toggleBurgerMenu() {
    if (this.searchBarSectionOpened()) {
      this.searchBarSectionOpened.set(false);
    }
    this.burgerMenuOpened.set(!this.burgerMenuOpened());
  }

  get activeLang() {
    return this.translationService.getActiveLang();
  }

  changeLang(lang: string) {
    // Ensure new active lang is loaded
    this.subscription?.unsubscribe();
    this.subscription = this.translationService
      .load(lang)
      .pipe(take(1))
      .subscribe(() => {
        this.translationService.setActiveLang(lang);
        this._languageService.setLanguage(lang);
        this.currentLang.set(lang);
      });
    this.toggleLanguageMenu();
  }

  onRouteChange(url: string) {
    this.updateHeaderForRoute(url);
  }

  updateHeaderForRoute(url: string) {
    this.isErrorPage.set(url.startsWith("/error"));
    if (url.includes("/questionnaire")) {
      this.canChangeLanguage.set(false);
    } else {
      this.canChangeLanguage.set(true);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.subscription = null;
  }
}
